import React from 'react'
import { Redirect } from 'react-router-dom'

import {
  routes,
  IndexLayoutOldSubtitle,
  IndexLayoutOldTitle,
  setSketchUrlScheme,
  IndexLayoutExtraProps,
  IndexLayoutContent,
  redirectAbsoluteSafely,
} from '@sketch/modules-common'
import { Button, LoadingState } from '@sketch/components'
import { Wrapper } from './SsoSuccessfulSigninView.styles'
import { useSsoSuccessfulSignIn } from './useSsoSuccessfulSignIn'
import { SKETCH_ENV_URL } from '@sketch/env-config'

interface SSOSuccessPopupProps {
  workspaceName: string
}

const SSOSuccessPopup = ({ workspaceName }: SSOSuccessPopupProps) => {
  return (
    <IndexLayoutContent center="horizontal" marginTop paddingHorizontal>
      <Wrapper>
        <IndexLayoutOldTitle>
          You are now signed in into &quot;{workspaceName}&quot;
        </IndexLayoutOldTitle>
        <IndexLayoutOldSubtitle>
          Please close this window and resume your work on the main one
        </IndexLayoutOldSubtitle>
        <Button variant="primary-untinted" onClick={window.close}>
          Close window
        </Button>
      </Wrapper>
    </IndexLayoutContent>
  )
}

export interface SsoSuccessfulSignInViewProps extends IndexLayoutExtraProps {}

const SsoSuccessfulSignInView = (props: SsoSuccessfulSignInViewProps) => {
  const { state } = useSsoSuccessfulSignIn()

  switch (state.type) {
    case 'loading':
      return <LoadingState />
    case 'success-cloud-popup':
      return <SSOSuccessPopup {...props} workspaceName={state.workspaceName} />
    case 'success-cloud': {
      if (state.from && redirectAbsoluteSafely(state.from)) {
        return <LoadingState />
      }
      return <Redirect to={state.from ?? routes.ENTRY.create({})} />
    }
    case 'success-sketch-app': {
      const redirectUrl = `${SKETCH_ENV_URL}/signin/sso/success?token=${state.exchangeToken}`
      window.location.href = setSketchUrlScheme(redirectUrl)
      return null
    }
    case 'error':
      return <Redirect to={routes.SSO_SIGN_IN.create({})} />
  }
}

export default SsoSuccessfulSignInView
